// components/ReservationSection.jsx

import React from "react";
import styles from "../styles/ReservationSection.module.css";
import BackgroundImage from "../images/mesogeios-restaurant.jpg";

export default function ReservationSection() {
  return (
    <section className={styles.section} id="reservation" style={{backgroundImage: `url(${BackgroundImage}`}}>
      <div className={styles.overlay}></div>

      <div className={styles.content}>
        <span>Reservation</span>

        <h2>Book Your Table Today</h2>

        <p>
          Enjoy unforgettable Mediterranean flavors and elegant dining in the
          heart of Corfu.
        </p>

        <a href="tel:+306900000000">Call For Reservation</a>
      </div>
    </section>
  );
}